<script>
  import { Stack } from "creditdesign-svelte-components";
  import {
    secondaryCategories,
    selectedCategoryOne,
    selectedCategoryTwo,
  } from "../../data/store.js";

  export let categories = [];
  export let expanded;
</script>

<style>
  fieldset {
    max-width: none;
    padding: var(--s1);
    background-color: var(--white-0);
    border-color: var(--black-2);
    border-style: solid;
    border-width: 2px;
    border-radius: 10px;
    box-shadow: inset 0 0.1em 0.1em rgba(27, 31, 35, 0.2);
  }

  legend {
    font-weight: 600;
  }

  select {
    width: calc(100% - var(--s1));
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 1rem;
    color: var(--black-1);
    background: #fff
      url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
      no-repeat right 0.75rem center/8px 10px;
    border: 1px solid var(--black-2);
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  select:disabled {
    color: var(--black-1);
    background: var(--white-1);
    opacity: 1;
  }
</style>

<fieldset hidden="{!expanded}">
  <Stack stackSpace="var(--s-1)">
    <legend>Filter by category</legend>

    <label for="category-select-one">
      Choose a category to filter the list by:
    </label>
    <select
      name="categories"
      id="category-select-one"
      bind:value="{$selectedCategoryOne}"
    >
      <option value="">--Please choose a category--</option>
      {#each categories as category}
        <option value="{category.name}">{category.name}</option>
      {/each}
    </select>

    <label for="category-select-two">
      Choose a secondary category to filter the list by:
    </label>
    <select
      name="secondary-categories"
      id="category-select-two"
      bind:value="{$selectedCategoryTwo}"
      disabled="{!$selectedCategoryOne}"
    >
      <option value="">--Please choose a secondary category--</option>
      {#each $secondaryCategories as category (category)}
        <option value="{category}">{category}</option>
      {/each}
    </select>
  </Stack>
</fieldset>
